// extracted by mini-css-extract-plugin
export default {"buySellSelector":"BuySellSelector_buySellSelector__Ohkq9"};